function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.83333 4.66536C5.18899 4.66536 4.66666 5.1877 4.66666 5.83203V22.1654C4.66666 22.8097 5.18899 23.332 5.83333 23.332H22.1667C22.811 23.332 23.3333 22.8097 23.3333 22.1654V5.83203C23.3333 5.1877 22.811 4.66536 22.1667 4.66536H5.83333ZM2.33333 5.83203C2.33333 3.89903 3.90033 2.33203 5.83333 2.33203H22.1667C24.0997 2.33203 25.6667 3.89903 25.6667 5.83203V22.1654C25.6667 24.0984 24.0997 25.6654 22.1667 25.6654H5.83333C3.90033 25.6654 2.33333 24.0984 2.33333 22.1654V5.83203Z",
  fill: "#FB1E5B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.67504 9.67374C10.1306 9.21813 10.8693 9.21813 11.325 9.67374L18.325 16.6737C18.7806 17.1294 18.7806 17.868 18.325 18.3237C17.8693 18.7793 17.1307 18.7793 16.675 18.3237L9.67504 11.3237C9.21943 10.868 9.21943 10.1294 9.67504 9.67374Z",
  fill: "#FB1E5B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.325 9.67374C18.7806 10.1294 18.7806 10.868 18.325 11.3237L11.325 18.3237C10.8693 18.7793 10.1306 18.7793 9.67504 18.3237C9.21943 17.868 9.21943 17.1294 9.67504 16.6737L16.675 9.67374C17.1307 9.21813 17.8693 9.21813 18.325 9.67374Z",
  fill: "#FB1E5B"
});

var SvgCancel = function SvgCancel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCancel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cancel.2a36e1f9.svg";
export { ForwardRef as ReactComponent };